/* eslint-disable no-unused-expressions */

import { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";

class ServicesPayMethod extends Component {
  state = {
    data: {
      serviceName: "",
      payMethodId: "",
      username: "",
      password: "",
      additional: "",
      additional2:""
    },

    contentHeader: "Services Payment Method",

    dataUrl: "/api/data/GetServicePayMethods",
    singleItemUrl: "/api/data/GetServicePayMethod",
    editUrl: "/api/data/EditServicePayMethod",

    inEditMode: false,
    inModalMode: false,
    modalHeaderEdit: "Edit ServicesPayMethod",
    modalSubmitButtonLabelEdit: "Edit",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,
    payMethodsDropdown: [],

    tableData: [],
  };

  componentDidMount() {
    this.getData();
    this.GetPayMethodsDropdown();
  }

  GetPayMethodsDropdown() {
    post(
      "/api/data/GetAllPayMethods",
      null,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        payMethodsDropdown: apiResponse.data.respData.data,
      });
    });
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["serviceName"] = apiResponse.data.respData.data.EN_NAME;
      data["payMethodId"] = apiResponse.data.respData.data.PAY_METHOD_ID_FK;
      data["username"] = apiResponse.data.respData.data.USERNAME;
      data["password"] = apiResponse.data.respData.data.PASSWORD;
      data["additional"] = apiResponse.data.respData.data.ADDITIONAL;
      data["additional2"] = apiResponse.data.respData.data.ADDITIONAL2;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data.ID,
      });
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);
    submitData["id"] = this.state.editEntityId;
    
    post(
      this.state.editUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.serviceName"),
        field: "EN_NAME",
      },
      {
        id: 2,
        label: t("col.paymentMethod"),
        field: "METHOD_EN",
      },
      {
        id: 3,
        label: t("col.username"),
        field: "USERNAME",
      },
      {
        id: 4,
        label: t("col.password"),
        field: "PASSWORD",
      },
      {
        id: 5,
        label: t("col.additional"),
        field: "ADDITIONAL",
      },
      {
        id: 6,
        label: t("col.insertDate"),
        field: "INSERT_DATE",
      },
      {
        id: 7,
        label: t("col.lastUpdate"),
        field: "LAST_UPDATE",
      },
      {
        id: 8,
        label: t("col.actions"),
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB77"]) && (
                <div className="inner" title="Edit">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa-edit" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.servicesPaymentMethod")}</h4>
          </div>
          <div className="col flex-container-left">
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {t("dialog.editTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={t("btn.edit")}
                icon={this.state.modalSubmitButtonIconEdit}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "serviceName",
                label: t("col.serviceName"),
                disabled: true,
              },
              {
                type: "text",
                id: "password",
                label: t("col.password"),
                disabled: false,
              },
              {
                type: "dropdown",
                id: "payMethodId",
                label: t("col.paymentMethod"),
                options: this.state.payMethodsDropdown,
                disabled: false,
              },
              {
                type: "text",
                id: "additional",
                label: t("col.additional"),
                disabled: false,
              },
              {
                type: "text",
                id: "username",
                label: t("col.username"),
                disabled: false,
              },
              {
                type: "text",
                id: "additional2",
                label: t("col.additional"),
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(ServicesPayMethod);
